import Container from "@client/content/Containers/container";
import { getContainerProps, getRootContainerProps } from "@client/content/lib/helper";
import { type RootContainerProps } from "@client/content/types";
import { type WithIsEditMode } from "@client/types";
import * as React from "react";
import Product from "./Product/container";
import "./style.less";

export type MapProps = RootContainerProps &
  WithIsEditMode & {
    hasProduct: boolean;
  };

export interface ActionProps {}

export default (props: ActionProps & MapProps) => (
  <Container className="wsc_content_product_detail" {...getContainerProps(props)}>
    {props.hasProduct ? (
      <Product {...getRootContainerProps(props)} />
    ) : props.isEditMode ? (
      "There's no product to display"
    ) : null}
  </Container>
);
